import ForgottenModal from './ForgottenModal.jsx'

export default ForgottenModal;



// WEBPACK FOOTER //
// ./src/components/ForgottenModal/index.js